import { isDirectUtilityObservedDataSource } from '../../services/energyFormatUtilitySources';

export type GasSourceStatus = 'observed' | 'interpolated' | 'estimated' | 'unknown';

export type NormalizedGasProvider = {
  provider: string;
  source_product: string;
  source_status: GasSourceStatus;
  measurement: string;
  customer_class: string;
};

function providerFromDataSource(dataSource: string): string {
  const raw = (dataSource || '').trim();
  if (!raw) return '';
  const c = raw.toLowerCase().replace(/[^a-z0-9]+/g, '');
  if (c.includes('socalgas') || c.includes('southerncaliforniagas') || c === 'scg') {
    return 'Southern California Gas Company';
  }
  if (c === 'pge' || c.includes('pacificgas')) return 'Pacific Gas and Electric Company';
  if (c.includes('sdge') || c.includes('sandiegogas')) return 'San Diego Gas & Electric';
  if (c.includes('sce') || c.includes('southerncaliforniaedison')) return 'Southern California Edison';
  return raw;
}

export function normalizeGasProviderFields(params: {
  data_source: string;
  measurement: string;
  method_note: string;
  sector: string;
}): NormalizedGasProvider {
  const dataSource = (params.data_source || '').trim();
  const measurement = (params.measurement || '').trim().toLowerCase();
  const methodNote = (params.method_note || '').trim().toLowerCase();
  const sector = (params.sector || '').trim();

  let source_status: GasSourceStatus = 'unknown';
  if (measurement === 'observed') source_status = 'observed';
  else if (measurement.includes('interpol') || methodNote.includes('interpol')) source_status = 'interpolated';
  else if (measurement === 'estimated' || methodNote.includes('extrapol') || methodNote.includes('county ratio')) {
    source_status = 'estimated';
  }

  const provider = providerFromDataSource(dataSource);
  const directUtility = isDirectUtilityObservedDataSource(dataSource, measurement);
  const source_product = directUtility
    ? 'DIRECT_UTILITY_DATA'
    : dataSource
      ? dataSource
      : '';

  const customer_class =
    /commercial/i.test(sector) ? 'Commercial' : /residential/i.test(sector) ? 'Residential' : sector;

  return {
    provider,
    source_product,
    source_status,
    measurement: measurement || 'unknown',
    customer_class,
  };
}

/** Methodology publish only when utility provenance is verified (direct utility observed). */
export function isVerifiedGasProvenance(params: {
  data_source: string;
  measurement: string;
}): boolean {
  return isDirectUtilityObservedDataSource(params.data_source, params.measurement);
}
